module.exports = __webpack_public_path__ + "static/media/trame.f31bc923.jpg";